import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";
import { getDate } from "../../helpers/actions";
import MotivatorsEditForm from "./MotivatorsEditForm";
import MotivatorsExport from "./MotivatorsExport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";


function MotivatorsListItem({ id, data, onSave }) {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const availableLan = useGetAvailableLanguages();

    const handleOpen = () => {
        setIsOpen(!isOpen);
        // if (newName) setName(newName);
    };

    //return (<div>{JSON.stringify(data)}</div>);

    return (
        <>
            <div id={id}>
                {!isOpen ? (
                    <div className="prizeGameAdmin-list" onClick={() => handleOpen()}>
                        {availableLan.map((lng, key) => (

                            <strong key={lng}>
                                <strong>{lng}: </strong>{data.title[lng]}
                                {!data.title[lng] && <span className="noTranslation" />}
                            </strong>
                        ))}
                        <em>
                            {getDate(data.start_date, 'dd.MM.yyyy')} - {getDate(data.end_date, 'dd.MM.yyyy')} • {(data.registered_users.length ? data.registered_users.length : 0)} {t("admin.prize.part", { count: (data.registered_users.length ? data.registered_users.length : 0) })}
                            {data.active && <span className="p-2"><FontAwesomeIcon icon={faCircleCheck} style={{ color: "#07bc0c" }} data-tooltip-content={t("admin.inv.invSent")} /></span>}
                        </em>
                        <button className="btn btn-default btn-edit"
                            onClick={handleOpen}
                            title={t("admin.common.edit")} />


                    </div>
                ) : (<>
                    <MotivatorsEditForm id={id} data={data} onClose={handleOpen} onSave={onSave} />
                    <MotivatorsExport id={id} data={data} />
                </>)}
            </div>
        </>
    );
}

export default MotivatorsListItem;


